module.exports = __webpack_public_path__ + "img/tuin_westkant.ab1b06ec.png";